export function checkSecurity(navigate, page) {
  if (!localStorage.getItem('isAuthenticated')) {
    navigate('/authentification');
  } else {
    if (page === 'Home') { return; }
    if (page === 'TrainingSearch') { return; }
    if (page === 'TrainingStaffin') { return; }
    navigate('/accueil', { replace: true });
  }
}
